const actions = {
	GET_HIGHLIGHT_INCORRECT_WORD: 'GET_HIGHLIGHT_INCORRECT_WORD',
	GET_HIGHLIGHT_INCORRECT_WORD_SUCCESS: 'GET_HIGHLIGHT_INCORRECT_WORD_SUCCESS',

	CREATE_NEW_QUESTION_HIGHLIGHT_INCORRECT_WORD: 'CREATE_NEW_QUESTION_HIGHLIGHT_INCORRECT_WORD',
	CREATE_NEW_QUESTION_HIGHLIGHT_INCORRECT_WORD_SUCCESS: 'CREATE_NEW_QUESTION_HIGHLIGHT_INCORRECT_WORD_SUCCESS',

	DELETE_HIGHLIGHT_INCORRECT_WORD: 'DELETE_HIGHLIGHT_INCORRECT_WORD',
	DELETE_HIGHLIGHT_INCORRECT_WORD_SUCCESS: 'DELETE_HIGHLIGHT_INCORRECT_WORD_SUCCESS',

	GET_HIGHLIGHT_INCORRECT_WORD_DETAIL: 'GET_HIGHLIGHT_INCORRECT_WORD_DETAIL',
	GET_HIGHLIGHT_INCORRECT_WORD_DETAIL_SUCCESS: 'GET_HIGHLIGHT_INCORRECT_WORD_DETAIL_SUCCESS',

	UPDATE_HIGHLIGHT_INCORRECT_WORD_DETAIL: 'UPDATE_HIGHLIGHT_INCORRECT_WORD_DETAIL',
	UPDATE_HIGHLIGHT_INCORRECT_WORD_DETAIL_SUCCESS: 'UPDATE_HIGHLIGHT_INCORRECT_WORD_DETAIL_SUCCESS',

	LISTENING_LOADING_FALSE: 'LISTENING_LOADING_FALSE',
	//#region CRUD

	getHighlightInCorrectWord: (model) => ({
		type: actions.GET_HIGHLIGHT_INCORRECT_WORD,
		payload: { model },
	}),

	createQuesHighlightInCorrectWord: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_HIGHLIGHT_INCORRECT_WORD,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getHighlightInCorrectWordDetail: (id) => ({
		type: actions.GET_HIGHLIGHT_INCORRECT_WORD_DETAIL,
		payload: { id },
	}),

	updateHighlightInCorrectWordDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_HIGHLIGHT_INCORRECT_WORD_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteHighlightInCorrectWord: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_HIGHLIGHT_INCORRECT_WORD,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
